import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './stores'
import '@/plugins/dayjs.plugin'

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPrompt = e;
  console.log('beforeinstallprompt event stashed.');
});

window.addEventListener('appinstalled', () => {
  window.deferredPrompt = null;
  console.log('PWA was successfully installed.');
});
